import { DrawerPanel } from '@dmc/ui';
import { ModelName } from '@casops/store/api';
import HoldTimeForm from './components/hold-time-form/HoldTimeForm';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import useLoadModelData from '@casops/components/layout/model-form/useLoadModelData';
import { useGetGeofenceHoldTimeQuery } from '@casops/store/apis/geofenceHoldTimesApi';
import { useModelFormTitle } from '@casops/components/layout/model-form/useModelFormTitle';
import { ReactElement } from 'react';

const modelName = ModelName.GeofenceHoldTime;

export function ManageGeofenceHoldTime(): ReactElement {
  const title = useModelFormTitle(modelName);

  const { isLoaded, item } = useLoadModelData({
    useModelQueryHook: useGetGeofenceHoldTimeQuery,
  });

  // The renderKey must update whenever the item data changes to ensure the form is remounted and RHK and VDS stay in sync.
  const renderKey = useRenderKey(item ? item : 'create-form');

  return (
    <DrawerPanel isLoaded={isLoaded} header={title}>
      <HoldTimeForm key={renderKey} item={item} />
    </DrawerPanel>
  );
}

export default ManageGeofenceHoldTime;
